import { Menu } from "antd";
import {
  BankOutlined,
  DollarCircleOutlined,
  FolderOutlined,
  MessageOutlined,
  PhoneOutlined,
  ToolOutlined,
  CommentOutlined,
  UploadOutlined
} from "@ant-design/icons";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFolderPagina, startGetHistorial } from "../../../context/actions/detalleActions";
import { CLIENTES_IDS, PAGINA_DETALLE } from "../../../constants/cons";

export default function MenuDetalle() {
  const dispatch = useDispatch();
  const [current, setCurrent] = useState("sucursales");

  //const {connection} = useSelector((state) => state.chatReducer);
  const { asistenciaID } = useSelector(
    (state) => state.detalleReducer.asistencia
  );
  const proveedorSucursal = useSelector(
    (state) => state.detalleReducer.asistencia.proveedorSucursal
  );
  const clienteID = useSelector(
    (state) => state.detalleReducer.asistencia.asegurado?.campania?.clienteID
  );

  const handleClick = ({ key }) => {
    setCurrent(key);
    dispatch(setFolderPagina(key));

    if (key === PAGINA_DETALLE.hisotrial) {
      dispatch(startGetHistorial(asistenciaID));
    }
  };

  // const onClickChat = () => {
  // 	connection?.send("LoadMensajesChatAsistencia", asistenciaID);
  // 	connection?.send("UpdateChatCabinaNoLeido", asistenciaID)
  // 	connection?.send("CountChatsCabinaNoLeidos")
  // };

  return (
    <>
      <Menu
        onClick={handleClick}
        selectedKeys={[current]}
        mode="horizontal"
        style={{ marginBottom: 15 }}
      >
        <Menu.Item key={PAGINA_DETALLE.proveedor} icon={<BankOutlined />}>
          Proveedor
        </Menu.Item>
        {/* <Menu.Item key={PAGINA_DETALLE.mapa} icon={<BankOutlined />}>
        Mapa
      </Menu.Item> */}

        <Menu.Item key={PAGINA_DETALLE.archivos} icon={<ToolOutlined />}>
          Archivos
        </Menu.Item>

        <Menu.Item
          key={PAGINA_DETALLE.hisotrial}
          icon={<DollarCircleOutlined />}
        >
          Historial
        </Menu.Item>

        <Menu.Item key={PAGINA_DETALLE.fotos} icon={<FolderOutlined />}>
          Fotos de servicio
        </Menu.Item>

        <Menu.Item key={PAGINA_DETALLE.sms} icon={<CommentOutlined />}>
          Comunicación
        </Menu.Item>

        {(clienteID === CLIENTES_IDS.EDEGA || clienteID === CLIENTES_IDS.EDEGA_PROD || clienteID === CLIENTES_IDS.EDEGA_QA) && (
          <Menu.Item key={PAGINA_DETALLE.edega} icon={<UploadOutlined />}>
            Edega
          </Menu.Item>
        )}

      </Menu>
    </>
  );
}
